import { isContractInProgressBetween } from './isContractInProgressBetween'

export function isContractInProgressAt(contract, date) {
  return isContractInProgressBetween(contract, date, date)
}
